var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg444(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 485,
    height: 500,
    viewBox: "0 0 485 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "444 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect43",
    d: "M95.4719 20.3372H8.38428V107.425H95.4719V20.3372Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect45",
    d: "M217.202 20.3383H130.113V107.427H217.202V20.3383Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect47",
    d: "M95.4719 144.352H8.38428V231.438H95.4719V144.352Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect49",
    d: "M217.202 144.353H130.113V231.441H217.202V144.353Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect51",
    d: "M339.325 20.712H252.237V107.8H339.325V20.712Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect53",
    d: "M461.056 20.7131H373.966V107.802H461.056V20.7131Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect55",
    d: "M339.325 144.727H252.237V231.813H339.325V144.727Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect57",
    d: "M461.056 144.728H373.966V231.816H461.056V144.728Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect59",
    d: "M95.4719 268.742H8.38428V355.831H95.4719V268.742Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect61",
    d: "M217.202 268.742H130.113V355.831H217.202V268.742Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect63",
    d: "M95.4719 392.756H8.38428V479.844H95.4719V392.756Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect65",
    d: "M217.202 392.759H130.113V479.846H217.202V392.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect67",
    d: "M339.325 268.742H252.237V355.829H339.325V268.742Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect69",
    d: "M461.056 268.742H373.966V355.831H461.056V268.742Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect71",
    d: "M339.325 392.756H252.237V479.844H339.325V392.756Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect73",
    d: "M461.056 392.759H373.966V479.846H461.056V392.759Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg444);
export default __webpack_public_path__ + "static/media/444.b83b376798669ce94be1b4e722bd7397.svg";
export { ForwardRef as ReactComponent };